import { createContext } from 'react';
import type { AppOptions } from 'types';

const AppOptionsContext = createContext<AppOptions | undefined>(undefined);
AppOptionsContext.displayName = 'AppOptionsContext';

export { AppOptionsContext };
